import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import * as actions from "../../../services/actions"

// Components
import HeaderRow from "./HeaderRow"
import TableRow from "./TableRow"
import CardHeader from "../CardHeader/CardHeader"
import ErrorState from "../ErrorState/ErrorState"
import Pagination from "../Pagination/Pagination"
import { getPaginatedData } from "../Pagination/Pagination.utils"
import { getPageNumber } from "../../../services/selectors/visionSelectors"

const CircleChart = props => {
  // Data
  const { data, keys, title, childLevel, headerClassName, pageNumber } = props

  // Styling
  const rowSpacing = {
    flex: `1 1 ${Math.floor((1 / keys.length) * 100)}%`,
    minWidth: "11vw"
  }

  const rowProps = {
    keys,
    rowSpacing,
    childLevel
  }

  const paginationProps = {
    data,
    limit: 10,
    totalCount: data.length,
    defaultPage: 1
  }

  const paginationRows = getPaginatedData(data, pageNumber, 10)

  return (
    <div className="card">
      <CardHeader
        header={{ title }}
        noBottomBorder="border-bottom-0 mt-0"
        titleSize="h2"
        className={headerClassName}
      />
      {Object.keys(data).length > 1 ? (
        <div className="mb-0 pt-0 py-0 circles-table demo-circles-table">
          <HeaderRow keys={keys} rowSpacing={rowSpacing} />
          {paginationRows.map(rowData => {
            return (
              <TableRow {...rowProps} rowData={rowData} key={Math.random()} />
            )
          })}
          <Pagination {...paginationProps} />
        </div>
      ) : (
        <div className="center-text">
          <ErrorState />
        </div>
      )}
    </div>
  )
}

CircleChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      scores: PropTypes.arrayOf(
        PropTypes.shape({
          key: PropTypes.string,
          scores: PropTypes.shape({
            score: PropTypes.number
          })
        })
      )
    })
  ).isRequired,
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string,
  childLevel: PropTypes.string,
  headerClassName: PropTypes.string,
  pageNumber: PropTypes.number,
  actions: PropTypes.shape({
    getPageNumber: PropTypes.func
  }).isRequired
}

CircleChart.defaultProps = {
  title: "",
  childLevel: null,
  headerClassName: null,
  pageNumber: 1
}

const mapStateToProps = state => ({
  pageNumber: getPageNumber(state)
})

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    actions: bindActionCreators(actions, dispatch)
  }
}

// export CircleChart
export default connect(mapStateToProps, mapDispatchToProps)(CircleChart)
